import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import useJwt from "./auth/jwt/useJwt";
import { setContext } from "apollo-link-context";
const authLink = setContext((_, { headers }) => {
  const token = useJwt.getToken();
  // console.log("token", token);

  if (token) {
    return {
      headers: {
        ...headers,
        authorization: `${token}`,
      },
    };
  }
  return headers;
});

// const BASE_URL_ENDPOINT = process.env.VUE_APP_GRAPHQL_ENDPOINT_URL;
// process.env.NODE_ENV === "production" ? process.env.VUE_APP_GRAPHQL_ENDPOINT_URL : process.env.VUE_APP_GRAPHQL_ENDPOINT_URL_LOCAL;
// Create customFetch function for handling re-authorization
// This customFetch (or any fetch you pass to the link) gets uri and options as arguments. We'll use those when we actually execute a fetch.
const customFetch = (uri, options) => {
  // console.log("customFetch");
  // This reference to the refreshingPromise will let us check later on if we are executing getting the refresh token.
  var refreshingPromise = null;

  // Create initial fetch, this is what would normally be executed in the link without the override
  var initialRequest = fetch(uri, options);

  // The apolloHttpLink expects that whatever fetch function is used, it returns a promise.
  // Here we return the initialRequest promise
  return initialRequest.then(async (response) => {
    var result = response.clone();
    var json = await response.json();
    // We should now have the JSON from the response of initialRequest
    // We check that we do and look for errors from the GraphQL server
    // If it has the error 'User is not logged in' (that's our implementation of a 401) we execute the next steps in the re-auth flow
    // Grab the refresh token from the store
    var refresh_token = useJwt.getRefreshToken();
    // console.log("json", json);
    // console.log("json.errors", json.errors);
    // console.log(" json.errors[0].extensions", json.errors[0].extensions);
    // console.log(
    //   " json.errors[0].extensions.code",
    //   json.errors[0].extensions.code
    // );
    if (
      json &&
      json.errors &&
      json.errors[0].extensions &&
      json.errors[0].extensions.code === "UNAUTHENTICATED"
    ) {
      // console.log("inside if");
      if (!refreshingPromise && refresh_token) {
        // console.log("refresh token call ");
        // Execute the re-authorization request and set the promise returned to refreshingPromise
        refreshingPromise = fetch(uri, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: `mutation { refreshToken(refresh_token:"${refresh_token}") { token refresh_token} }`,
          }),
        }).then((refresh_token_response) => {
          // console.log("refresh_token_response", refresh_token_response);
          if (refresh_token_response) {
            return refresh_token_response.json().then((refreshJSON) => {
              // console.log("refreshJSON call", refreshJSON.errors);
              if (refreshJSON.errors) {
                // If the re-authorization request fails, handle it here
                // You can log user out, or display some sort of session has ended alert
                // logUserOut()
                localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
                useJwt.setToken("");
                useJwt.setRefreshToken("");
                localStorage.clear();
                //  this.$router.push("/");
                // self.$router.push("/login");
                // this.$router.push({ path: "/login" });
                // if (this.$route.path != "/") {
                // } else {
                //   this.$router.go();
                // }
                throw Error("UNAUTHENTICATED");
              }
              // console.log("save new refresh token call");
              // Save the new refresh token to your store or wherever you are keeping it
              useJwt.setToken(refreshJSON.data.refreshToken.token);
              useJwt.setRefreshToken(
                refreshJSON.data.refreshToken.refresh_token
              );

              // Return the new access token as a result of the promise
              return refreshJSON.data.refreshToken.token;
            });
          }
        });
      }
      return refreshingPromise
        .then((newAccessToken) => {
          if (newAccessToken) {
            // Now that the refreshing promise has been executed, set it to null
            refreshingPromise = null;

            // Set the authorization header on the original options parameter to the new access token we got
            options.headers.authorization = `${newAccessToken}`;
            // Return the promise from the new fetch (which should now have used an active access token)
            // If the initialRequest had errors, this fetch that is returned below is the final result.
          }
          return fetch(uri, options);
        })
        .catch((err) => {
          throw err;
        });
    }
    // If there were no errors in the initialRequest, we need to repackage the promise and return it as the final result.
    return result;
  });
};

// HTTP connection to the API
const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri:
    process.env.NODE_ENV === "development"
      ? process.env.VUE_APP_GRAPHQL_ENDPOINT_URL_LOCAL
      : process.env.VUE_APP_GRAPHQL_ENDPOINT_URL,
  // uri: BASE_URL_ENDPOINT,
  fetch: customFetch,
});
const defaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore",
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  },
};

// Create the apollo client
const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions,
});

export default apolloClient;
